import React, { useEffect, useRef, useState, useCallback } from 'react';
import './NFT.css';
import { useDaily, useLocalSessionId } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { isAuthAtom, nftDetailAtom, BGMAtom } from '../../State';
import { ReactComponent as SelectedSVG } from '../Images/buttons/nftSelected.svg';
import { ReactComponent as SelectedBackSVG } from '../Images/buttons/selectedBack.svg';

import DataModel from '../Util/DataModel';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import isElectron from '../../Global';
import AddAccess from '../Util/AddAccess';
import { getImagePath } from '../Util/utils';

export default function NFTBGMItem({ imageURL }) {
  //Daily系
  const callObject = useDaily();
  const localSessionID = useLocalSessionId();
  const [BGMState, setBGMState] = useRecoilState(BGMAtom);

  //Recoil系
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);

  //その他
  const [loadingState, setLoadingState] = useState(false);
  var isSelected = false;

  async function selectNFT() {
    //変更
    setBGMState(imageURL);

    //セッションに保存
    saveData(imageURL);
  }

  var finalImageURL = imageURL;

  //カスタムの場
  if (imageURL.startsWith('custom')) {
    let fileType = imageURL.split('.').pop();
    finalImageURL = getImagePath() + '/background/musicThumb.png';
  }
  //通常の場合
  else {
    if (imageURL == 'bgm1.mp3') {
      finalImageURL = getImagePath() + '/background/bgm2.png'; //+ imageURL;
    } else if (imageURL == 'bgm2.mp3') {
      finalImageURL = getImagePath() + '/background/bgm1.png'; //+ imageURL;
    }
  }

  //選択中かどうか
  if (BGMState == imageURL) {
    isSelected = true;
  }

  //画像のローディング完了トリガー
  const loadCompleted = async () => {
    setLoadingState(true);
  };

  //データベースに保存
  function saveData(imageURL) {
    if (callObject != null) {
      //データベースに保存
      callObject
        .getMeetingSession()
        .then(async (session) => {
          try {
            //自分の情報をseessionに登録
            await DataModel.saveSessionToRoom(
              null, //ルームID
              session.meetingSession.id, //ルームのセッションID
              localSessionID, //ユーザーのテンポラリーユーザーID
              null, //顔
              null, //背景
              null, //顔認識 <isFaceTrackingå>
              null, //録画中
              null, //ミュート
              null, //WhoUse
              null, //ユーザー他タイプ
              imageURL, //BGM
              null, //BGMボリューム
            );

            console.log('セッション保存完了');
          } catch (error) {
            console.log(error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  return (
    <>
      <div className="nftPartnerItem">
        <div className="relativeBox">
          <img
            src={finalImageURL}
            onClick={selectNFT}
            onError={(e) => (e.target.style.display = 'none')}
            onLoad={loadCompleted}
            style={{
              borderRadius: '50%',
              display: !loadingState ? 'none' : 'block',
              width: '70px',
            }}
          />

          {isSelected && (
            <div className="nftSelected">
              <SelectedSVG />
            </div>
          )}

          {!loadingState && (
            <>
              <Skeleton
                circle={true}
                baseColor={'#ccc'}
                highlightColor={'#fff'}
                height={'70px'}
                width={'70px'}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}
